import { NgFor, NgIf } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { SortingType } from '../../../../api/api-reference';

@Component({
  selector: 'app-sort',
  standalone: true,
  imports: [NgFor, NgIf, TranslateModule],
  templateUrl: './sort.component.html',
  styleUrls: ['./sort.component.scss'],
})
export class SortComponent {
  @Output() close = new EventEmitter<any>();

  isSortOpen = false;
  public selectedOption: string | undefined = 'DESCENDING';

  toggleModal(option?: string) {
    if (option) {
      this.selectedOption =
        this.sortingTypeDictionary.find((item) => item === option) ||
        this.selectedOption;
      this.close.emit(option);
    }
    this.isSortOpen = !this.isSortOpen;
  }

  sortingTypeTranslations: { [key in SortingType]: string } = {
    [SortingType.Ascending]: 'ASCENDING',
    [SortingType.Descending]: 'DESCENDING',
  };

  sortingTypeDictionary: string[] = Object.keys(SortingType)
    .filter((key) => isNaN(Number(key)))
    .map(
      (key) =>
        this.sortingTypeTranslations[
          SortingType[key as keyof typeof SortingType]
        ],
    );
}
